export const getSet = async (extentionID) => {
    try {
        const response = await fetch ("https://optcgapi.com/api/sets/" + extentionID)
        const set = await response.json()
        return set
    } catch (error) {
        console.log("Error when getting set", extentionID, ":", error)
    }
}

export const getDeck = async (extentionID) => {
    try {
        const response = await fetch ("https://optcgapi.com/api/decks/" + extentionID)
        const set = await response.json()
        return set
    } catch (error) {
        console.log("Error when getting deck", extentionID, ":", error)
    }
}

export const getCard = async (cardID) => {
    try {
        const response = await fetch("https://optcgapi.com/api/sets/card/" + cardID);

        if (!response.ok) {
            if (response.status === 404) {
                return "Card not found";
            }
        }

        const card = await response.json();
        return card;

    } catch (error) {
        console.log("Error when getting card", cardID, ":", error);
        return "Card not found";
    }
};
